import { render } from "./edit-availability.vue?vue&type=template&id=aaf36696&ts=true"
import script from "./edit-availability.vue?vue&type=script&lang=ts"
export * from "./edit-availability.vue?vue&type=script&lang=ts"

import "./edit-availability.vue?vue&type=style&index=0&id=aaf36696&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__